import jwt from 'jsonwebtoken';

const {
  VUE_APP_EVENTID,
  VUE_APP_HOURID,
  VUE_APP_API_URL,
  VUE_APP_API_NODE,
  VUE_APP_EVENTID_CRC,
  VUE_APP_HOURID_CRC,
  VUE_APP_EVENTID_COL,
  VUE_APP_HOURID_COL,
  VUE_APP_VISANET_JS,
  VUE_APP_VISANET_ID,
  VUE_APP_MASTERCARD_JS,
  VUE_APP_DINERS_JS,
  VUE_APP_AMEX_JS,
  VUE_APP_PROCESOS_ID,
} = process.env;

const formatTwo = n => (n > 9 ? `${n}` : `0${n}`);

export default {
  data() {
    return {
      eventId: VUE_APP_EVENTID,
      hourId: VUE_APP_HOURID,
      eventIdCrc: VUE_APP_EVENTID_CRC,
      hourIdCrc: VUE_APP_HOURID_CRC,
      eventIdCol: VUE_APP_EVENTID_COL,
      hourIdCol: VUE_APP_HOURID_COL,
      projectKey: 'bbva',
      eventName: 'Partido Perú vs Brasil',
      eventImg: 'https://s3.us-west-2.amazonaws.com/joinnus.com/files/peruvsbrasil.jpg',
      termsPdf: 'https://s3.us-west-2.amazonaws.com/joinnus.com/files/termino_condiciones_joinnus_fpf_2020.pdf',
      privacyPdf: 'https://s3-us-west-2.amazonaws.com/joinnus.com/content/terms/politica-de-privacidad-joinnus-v.15.pdf',
      termsPdfBbva: 'https://s3.us-west-2.amazonaws.com/joinnus.com/files/termino_condiciones_bbva_2020.pdf',
      termsPdfBbvaWin: 'https://s3-us-west-2.amazonaws.com/joinnus.com/files-fpf/qatar/terminos-condiciones-campania-exclusiva-marzo-2020.pdf',
      restrictionsPdf: 'https://s3.us-west-2.amazonaws.com/joinnus.com/files/Restricciones_y_prohibiciones.pdf',
      stadiumName: 'Estadio Nacional',
      dateEvent: '31/03/2020',
      dateHourEvent: '09:15 PM',
      dateFirst: 'Martes 31 Marzo, 2020 - 09:15 pm',
      // dateSecond: 'Miércoles 25 Setiembre, 2019 - 08:00 pm',
      versus: {
        name: 'Perú vs Brasil',
        smallName: 'PER vs BRA',
        smallSecond: 'BRA',
      },
      apiUrl: VUE_APP_API_URL,
      apiNode: VUE_APP_API_NODE,
      siteKey: '6LcCpFIUAAAAAL2GBL6GQBu3-j0cNQJQl711NOzv',
      jsVisanet: VUE_APP_VISANET_JS,
      visanetMerchantId: VUE_APP_VISANET_ID,
      jsProcesosMastercard: VUE_APP_MASTERCARD_JS,
      jsProcesosDiners: VUE_APP_DINERS_JS,
      jsProcesosAmex: VUE_APP_AMEX_JS,
      procesosPagoMerchantId: VUE_APP_PROCESOS_ID,
    };
  },
  methods: {
    signToken(payload) {
      return jwt.sign(payload, 'jnputin');
    },
    dateFriend(date) {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Setiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ];
      const patrs = date.split('-');
      return `${patrs[2]} de ${months[parseInt(patrs[1], 0) - 1]} ${patrs[0]}`;
    },
    hourFriend(hour) {
      const patrs = hour.split('-');
      return `${this.parseHourString(patrs[0])} - ${this.parseHourString(patrs[1])}`;
    },
    parseHourString(time) {
      const patrs = time.split(':');
      let ampm = ' AM';
      if (patrs[0] >= 12) {
        ampm = ' PM';
      }
      if (patrs[0] > 12) {
        patrs[0] -= 12;
      }
      const formattedTime = `${formatTwo(parseInt(patrs[0], 0))}:${patrs[1]}${ampm}`;
      return formattedTime;
    },
    getFieldMeta(arr, key) {
      const search = arr.find(el => el.key === key);
      if (search) return search.charValue;
      return '[]';
    },
  },
};
